// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__24Zoc","disabled":"FileBtn_disabled__32Lxx","warn":"FileBtn_warn__3tgFm","fade":"FileBtn_fade__3Yv8E"};